import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { TestSubsection } from "./TestSection";
import { User, Settings as SettingsIcon, Calendar as CalIcon, Webhook, Key, Activity, Globe, DollarSign, Database } from "lucide-react";
import * as tests from "./testDefinitions";

export const SettingsSection = ({ testResults }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">Settings</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <TestSubsection
          icon={User}
          iconColor="text-blue-600"
          title="Profile"
          tests={tests.profileTests}
          results={testResults.profile}
        />
        
        <TestSubsection
          icon={SettingsIcon}
          iconColor="text-gray-600"
          title="Preferences"
          tests={tests.preferencesTests}
          results={testResults.preferences}
        />
        
        <TestSubsection
          icon={CalIcon}
          iconColor="text-purple-600"
          title="Calendar"
          tests={tests.calendarTests}
          results={testResults.calendar}
        />
        
        <TestSubsection
          icon={Webhook}
          iconColor="text-indigo-600"
          title="Webhooks"
          tests={tests.webhooksTests}
          results={testResults.webhooks}
        />
        
        <TestSubsection
          icon={Key}
          iconColor="text-yellow-600"
          title="API Keys"
          tests={tests.apiKeysTests}
          results={testResults.apiKeys}
        />
        
        <TestSubsection
          icon={Activity}
          iconColor="text-green-600"
          title="Activity Log"
          tests={tests.activityLogTests}
          results={testResults.activityLog}
        />
        
        <TestSubsection
          icon={Globe}
          iconColor="text-cyan-600"
          title="Widget API"
          tests={tests.widgetApiTests}
          results={testResults.widgetApi}
        />
        
        <TestSubsection
          icon={DollarSign}
          iconColor="text-emerald-600"
          title="Currency Consistency"
          tests={tests.currencyTests}
          results={testResults.currencyConsistency}
        />
        
        <TestSubsection
          icon={DollarSign}
          iconColor="text-blue-600"
          title="Multi-Currency Checkout"
          tests={tests.multiCurrencyCheckoutTests}
          results={testResults.multiCurrencyCheckout}
        />
        
        <TestSubsection
          icon={DollarSign}
          iconColor="text-purple-600"
          title="Add-Ons Data Integrity"
          tests={tests.addOnsDataTests}
          results={testResults.addOnsData}
        />
        
        <TestSubsection
          icon={DollarSign}
          iconColor="text-orange-600"
          title="Customer Ticket & Magic Links"
          tests={tests.customerTicketTests}
          results={testResults.customerTicket}
        />
        
        <TestSubsection
          icon={DollarSign}
          iconColor="text-cyan-600"
          title="Third-Party Integrations"
          tests={tests.integrationsTests}
          results={testResults.integrations}
        />
        
        <TestSubsection
          icon={Database}
          iconColor="text-amber-600"
          title="Data Migration & Cleanup"
          tests={tests.dataMigrationTests}
          results={testResults.dataMigration}
          endpoint="data-migration"
        />
      </CardContent>
    </Card>
  );
};
